/**
 * Tiny dev-only logger. In production, calls become no-ops so that:
 *  1. No debug info leaks to the DevTools console of end users.
 *  2. There's no runtime cost for the sprintf/format work done by console.
 *
 * Usage:
 *   import { devWarn, devError } from "@/lib/logger";
 *   devWarn("[foo]", err?.message);
 */
const isDev = process.env.NODE_ENV !== "production";

export const devWarn = (...args) => { if (isDev) console.warn(...args); };
export const devError = (...args) => { if (isDev) console.error(...args); };
export const devInfo = (...args) => { if (isDev) console.info(...args); };
